module.exports = __webpack_public_path__ + "img/Butterfly_00250.651434e1.png";